import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UploadStampExcel } from './upload-stamp-excel/upload-stamp-excel.component';
import { BulkOrdersComponent } from './bulk-orders/bulk-orders.component';
import { CreateCustomerOrderComponent } from './create-customer-order/create-customer-order.component';
import { CustomerOrderListComponent } from './customer-order-list/customer-order-list.component';
import { InventoryComponent } from './inventory/inventory.component';

const routes: Routes = [
  { path: 'create-order', component: UploadStampExcel },
  { path: 'bulk-order', component: BulkOrdersComponent },
  { path: 'create-customer-order', component: CreateCustomerOrderComponent },
  { path: 'customer-order-list', component: CustomerOrderListComponent },
  { path: 'inventory', component: InventoryComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EStampRoutingModule { }
